import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Experience } from "./components/Experience";
import { Services } from "./components/Services";
import { Packages } from "./components/Packages";
import { Addons } from "./components/Addons";
import { Gallery } from "./components/Gallery";
import { Testimonials } from "./components/Testimonials";
import { Brands } from "./components/Brands";
import { Contact } from "./components/Contact";
import { Footer, StickyMobileCTA } from "./components/Footer";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import FAQPage from "./pages/FAQPage";
import ReviewPage from "./pages/ReviewPage";
import { TermsPage, PrivacyPage } from "./pages/LegalPages";
import { scrollToSection } from "./lib/site";
import { BookingProvider } from "./lib/booking";
import { ContentProvider } from "./lib/content";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      window.history.replaceState({}, "");
      setTimeout(() => scrollToSection(target), 350);
    }
  }, [location.state]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Experience />
        <Services />
        <Packages />
        <Marquee dark />
        <Addons />
        <Gallery />
        <Testimonials />
        <Brands />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
    </>
  );
};

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ContentProvider>
          <BookingProvider>
            <ScrollReset />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/review" element={<ReviewPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
            </Routes>
          </BookingProvider>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
